import React, { Component } from 'react';
import {withRouter} from "react-router-dom";

class CustomerTableRow extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidUpdate() {
    }

    handleClick(e) {
        this.props.history.push('/customers/'+this.props.customer.id)
    }

    render() {
        return (
            <tr onClick={(e) => this.handleClick(e)}>
                <td>{this.props.customer.customerNumber}</td>
                <td>{this.props.customer.name}</td>
                <td>{this.props.customer.address.address}, {this.props.customer.address.city}</td>
                <td>{this.props.customer.configuration.privateCore.httpsEnabled ? "https://" : "http://"}{this.props.customer.configuration.privateCore.dns}:{this.props.customer.configuration.privateCore.httpPort}</td>
            </tr>
        );
    }
}

export default withRouter(CustomerTableRow);



// WEBPACK FOOTER //
// ./src/components/customer/CustomerTableRow.js